import {queryLocatins, getAllDeviceNames} from '@/api/location.js'
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
    name: 'Locatin',
    data() {
        return {
            pageInfo: {current: 1, size: 1000, siteName: "1"},
            queryParam: {current: 1, size: 1000, deviceName: "device_tracker.sm_g9730"},
            deviceNames: ['device_tracker.sm_g9730', 'device_tracker.zww_location', 'device_tracker.ny_op4e21', 'device_tracker.qsw_selene'],
            dateRange: [],
            map: null,
            grasp: null,
            path: null
        }
    },
    beforeCreate() {
        AMapLoader.load({
            "key": "9bf8412fd85ffd24f10e02f8c434c3f2",              // 申请好的Web端开发者Key，首次调用 load 时必填
            "version": "1.4.15",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            "plugins": ['AMap.GraspRoad'],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            "AMapUI": {             // 是否加载 AMapUI，缺省不加载
                "version": '1.1',   // AMapUI 缺省 1.1
                "plugins":[],       // 需要加载的 AMapUI ui插件
            },
            "Loca":{                // 是否加载 Loca， 缺省不加载
                "version": '1.3.2'  // Loca 版本，缺省 1.3.2
            },
        }).then((AMap)=>{
            this.grasp = new AMap.GraspRoad();
            this.initMap(AMap)
        }).catch(e => {
            console.log(e);
        })
    },
    mounted() {
        this.getAllDeviceNames()
    },
    methods: {
        queryLocatins(){
            if(this.dateRange.length>1){
                this.queryParam.day = this.dateRange[0]
                this.queryParam.endDay = this.dateRange[1]
            }
            let that = this
            queryLocatins(this.queryParam).then(data => {
                this.pageInfo = data.data
                var path1 = [];
                // var originPath= [];
                for(let location of data.data){
                    path1.push([location.longitude,location.latitude])
                    // originPath.push({"x":location.longitude,"y":location.latitude,"sp":19,"ag":0, "tm":0})
                }
                if (that.path != null){
                    that.map.remove(that.path)
                }

                // that.grasp.driving(originPath,function(error,result){
                //         if(!error){
                //             console.log(result.data.points)
                //             var newPath = result.data.points;//纠偏后的轨迹
                //             var distance = result.data.distance;//里程
                //         }
                // })
                
                AMapLoader.load({
                    plugins:['AMap.MapType']
                }).then((AMap)=>{
                    that.path = new AMap.Polyline({
                        path:path1,
                        strokeWeight:8,
                        strokeOpacity:0.8,
                        strokeColor:'#0091ea',
                        showDir:true
                    })
                    that.map.add(that.path)
                    that.map.setFitView()
                }).catch((e)=>{
                    console.error(e);
                });
            })
        },
        initMap(AMap) {
            this.map = new AMap.Map('location-map');
            this.grasp = new AMap.GraspRoad();
            this.queryLocatins()
        },
        getAllDeviceNames(){
            let that = this
            getAllDeviceNames().then(data => {
                console.log(data)
                // that.queryParam.deviceName = data.data[0]
                // this.deviceNames = data.data
            })
        }
    }
}